export default __webpack_public_path__ + "static/media/back2.6953e895.png";